import React from 'react';
import { BookOpen } from 'lucide-react';
import { CitedSource } from '../../types';

interface SourcesContainerProps {
  sources?: CitedSource[];
}

export function SourcesContainer({ sources }: SourcesContainerProps) {
  if (!sources || sources.length === 0) return null;

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center space-x-2">
        <BookOpen className="w-5 h-5 text-primary-600" />
        <span>Reference Sources</span>
      </h3>
      <p className="text-sm text-gray-600 mb-4">
        Background context the AI drew on alongside your symptom data, from this app's local knowledge base.
      </p>

      <div className="space-y-3">
        {sources.map((source, index) => (
          <div key={index} className="border border-gray-200 rounded-lg p-4">
            <div className="flex items-start justify-between gap-2 mb-1">
              <p className="font-medium text-gray-900">{source.docTitle}</p>
              {source.placeholder && (
                <span className="px-2 py-1 rounded text-xs font-medium uppercase bg-yellow-100 text-yellow-800 flex-shrink-0">
                  Placeholder
                </span>
              )}
            </div>
            <p className="text-xs text-gray-500 mb-2">{source.source}</p>
            <p className="text-sm text-gray-700">{source.excerpt}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
